import { useLayer, useStatsigClient } from '@statsig/react-bindings';

export const useStatsigLayer = (layerName: string) => {
  const { client } = useStatsigClient();
  const layer = useLayer(layerName);
  const isReady = client.loadingStatus === 'Ready';

  const get = (key: string, fallback?: string) => {
    if (!isReady) return fallback ?? '';
    return layer.get(key, fallback ?? '');
  };

  return { get, isReady, groupName: isReady ? layer.groupName : null };
};
